import "./Banglore_cities.css";
const Delhi_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">Mahipalpur</p>
            <p className="city">New Delhi Railway Station</p>
            <p className="city">Paharganj</p>
            <p className="city">Karol Bagh</p>
            <p className="city">Indira Gandhi International Airport</p>
            <p className="city">Dwarka, New Delhi</p>
            <p className="city">Rohini</p>
            <p className="city">Pitampura</p>
            <p className="city">All of Delhi</p>
           
        </div>
    )
}
export {Delhi_cities}